'use client';

import { m } from 'framer-motion';

import { useTranslate } from '@/core/locales';
import { TRANSLATION_NAMESPACES } from '@/core/constants';

import { ForbiddenIllustration } from '@/assets/illustrations';

import { Button, Container, Typography } from '@/components/ui';
import { varBounce, MotionContainer } from '@/components/animate';

import { paths } from '@/routes/paths';
import { RouterLink } from '@/routes/components';

export function View403() {
  const { t } = useTranslate(TRANSLATION_NAMESPACES.COMMON);

  return (
    <Container
      component={MotionContainer}
      className="max-w-md flex flex-col justify-center items-center py-30 text-center"
    >
      <m.div variants={varBounce('in')}>
        <Typography variant="h3" className="mb-2">
          {t('forbiddenPage.title')}
        </Typography>
      </m.div>

      <m.div variants={varBounce('in')}>
        <Typography className="text-gray-600">{t('forbiddenPage.description')}</Typography>
      </m.div>

      <m.div variants={varBounce('in')}>
        <ForbiddenIllustration className="my-5 sm:my-10" />
      </m.div>

      <Button component={RouterLink} href={paths.root} size="large" variant="contained">
        {t('forbiddenPage.homeButton')}
      </Button>
    </Container>
  );
}
